<!--  -->
<template>
  <div class="content">
    <div class="ban">
      <img src="../../assets/img/anli/banner.png" @click="jump" alt="" />
    </div>
    <!-- 平台介绍 -->
    <div class="Platform_introduction">
      <div class="card">
        <div class="left">
          <div class="all_text">
            <img src="../../assets/img/index/ico.png" alt="" />
            <div class="text">
              货物运输 <br />
              线上实操教学<br />
              平台简介
            </div>
            <div class="row"></div>
          </div>
          <div class="info">
            <div>
              货运教学平台主要功能为线上实操、智能对比、智能评分、成绩管理、案例管理、学员管理等操作。
            </div>
            <div>
              其中包含案例管理、现场管理、报价管理、单证管理、操作管理、统计查询、档案管理、成绩管理、成绩分析、竞赛题库、系统管理、合同管理、财务管理、报表管理等十四大功能模块。
            </div>
           
          </div>
        </div>
      </div>
      <div class="left_img">
        <img class="img" src="../../assets/servie/img.png" alt="" />
      </div>
    </div>

    <!-- 平台模板 -->
    <div class="Platform_template">
      <div class="img_ab">
        <img src="../../assets/img/anli/bg.png" alt="" />
      </div>
      <div class="info card">
        <Link text="平台主要功能模块" />

        <div class="">
          <div class="list card">
            <div
              class="li"
              v-for="(item, index) in card_list"
              :key="index"
              v-show="index < 5"
            >
              <img :src="item.img" alt="" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
          <div class="list card">
            <div
              class="li"
              v-for="(item, index) in card_list"
              :key="index"
              v-show="index > 4"
            >
              <img :src="item.img" alt="" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!-- 三大优势 -->
     <div class="four">
      <Link text="优势特点" />
      <div class="card">
        <div class="list">
          <div
            class="li"
            v-for="(item, index) in thress_list"
            :key="index"
            :style="index == 0 || index == 2 ? 'margin-top:83px;' : ''"
          >
            <img :src="item.background" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 六大功能 -->
    <div class="Six_functions">
      <Link text="平台六大功能特点" />
      <div class="card">
        <div class="list">
          <div
            class="li"
            v-for="(item, index) in six_list"
            :key="index"
            :class="index == 1 || index == 4 ? 'margin_top' : ''"
          >
            <img :src="item.background" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
import Footer from "../../components/footer";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
    Footer,
  },
  data() {
    //这里存放数据
    return {
      six_list: [
        {
          title: "线上实操",
          text: "数字化操作实现数据精准有效填写。",
          background: require("../../assets/img/anli/1.png"),
        },
        {
          title: "智能对比",
          text: "学生在实操录入后，系统会自动进行数据对比。",
          background: require("../../assets/img/anli/2.png"),
        },
        {
          title: "智能评分",
          text: "全流程记录学生实际录入操作，进行积分制，系统自动评分。",
          background: require("../../assets/img/anli/3.png"),
        },
        {
          title: "成绩管理",
          text: "快速查询学生实操结果，并统计所有实操信息。",
          background: require("../../assets/img/anli/4.png"),
        },
        {
          title: "案例管理",
          text: "在培训学习时，老师可在丰富的案例库中挑选和更新实操案例信息。",
          background: require("../../assets/img/anli/5.png"),
        },
        {
          title: "竞赛题库",
          text: "学生可操作世界技能大赛货运代理项目比赛试题。",
          background: require("../../assets/img/anli/6.png"),
        },
      ],
      card_list: [
        {
          img: require("../../assets/servie/ioc10.png"),
          text: "案例管理",
        },
        {
          img: require("../../assets/servie/ioc1.png"),
          text: "现场管理",
        },
        {
          img: require("../../assets/servie/ioc3.png"),
          text: "报价管理",
        },
        
        {
          img: require("../../assets/servie/ioc4.png"),
          text: "单证管理",
        },
        
        {
          img: require("../../assets/servie/ioc5.png"),
          text: "操作管理",
        },
        ////
        {
          img: require("../../assets/servie/16.png"),
          text: "统计查询",
        },
        {
          img: require("../../assets/servie/ioc12.png"),
          text: "档案管理",
        },
        {
          img: require("../../assets/servie/14.png"),
          text: "成绩管理",
        },
     
        
        {
          img: require("../../assets/servie/13.png"),
          text: "成绩分析",
        },
        
        
        {
          img: require("../../assets/servie/15.png"),
          text: "竞赛题库",
        },
      ],
      thress_list: [
        {
          title: "全流程操作模拟",
          text: "可实现货物由“发货客户工厂装货”到“送货完成”的全过程模拟操作和控制，按现实操作过程来进行数据采集，形成动态跟踪技术，通过该系统平台可以实现货物运输进度和轨迹的查询。",
          background: require("../../assets/img/Cycle/ico1.png"),
        },
        {
          title: "3大平台特点",
          text: "实战模拟（浩通线上货运实际运输操作流程）、真实案例（浩通根据多年货运经验及真实业务独创案例知识库）、独创讲义（浩通研发老师讲义和学生手册）",
          background: require("../../assets/img/Cycle/ico2.png"),
        },
        {
          title: "平台四件套",
          text: "仿真模拟的实验平台、全面易懂的老师讲义、源源不断的真实案例、海量的世界竞赛题库。",
          background: require("../../assets/img/Cycle/ico3.png"),
        },
       
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.$store.state.current = index;
      this.drawer = false;
      this.current = index;
      localStorage.setItem("current", this.current);
    },
    // 底部
    jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../service_education/pc);
@import url(../service_education/mod);
</style>